import { render, staticRenderFns } from "./new-task-input.vue?vue&type=template&id=30e836df"
import script from "./new-task-input.vue?vue&type=script&lang=js"
export * from "./new-task-input.vue?vue&type=script&lang=js"
import style0 from "./new-task-input.vue?vue&type=style&index=0&id=30e836df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports